import React, { useMemo } from 'react';
import { Form, FormInstance, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import ActionTypes from '@utils/deviceActions';
import {
  DeviceActionProps,
  DeviceActionStepsProps,
} from '@components/Actions/ActionsModal/types';
import { IDevice } from '@pages/Assets/Inventory/types';
import rolesConstants from '@utils/rolesConstants';

interface NicknameChangePayloadProps {
  action: ActionTypes.NICKNAME_CHANGE;
  devices: {
    msisdn: string;
    iccid: string;
    processData: string;
  }[];
}

interface NicknameChangeProps {
  devices: IDevice[];
  isUpload?: boolean;
  form: FormInstance<any>;
}

const useNicknameChange = ({
  devices,
  isUpload,
  form,
}: NicknameChangeProps): DeviceActionProps => {
  const { t } = useTranslation(['device-actions', 'attributes']);
  const newNickname = Form.useWatch('newNickname', form);

  const steps: DeviceActionStepsProps[] = useMemo(
    () => [
      {
        title: t('attributes:newNickname'),
        name: 'newNickname',
        content: <Input />,
      },
    ],
    [t],
  );

  const payloadToSend = useMemo(
    (): NicknameChangePayloadProps => ({
      action: ActionTypes.NICKNAME_CHANGE,
      devices: isUpload
        ? devices
        : devices?.map(device => ({
            msisdn: device.msisdn,
            iccid: device.iccid,
            processData: newNickname,
          })),
    }),
    [devices, newNickname, isUpload],
  );

  return {
    steps,
    title: t(`labels.common.${rolesConstants.NICKNAME_CHANGE}`),
    payloadToSend,
  };
};

export default useNicknameChange;
